import React from 'react';
import { Navbar, Card, Container, Nav } from 'react-bootstrap';
import { connect } from 'react-redux';
import axios from 'axios';
import { PromptDialog } from './Dialog/Message';

let monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];
let date = new Date();
const falseVal = false;
class Header extends React.Component {
  constructor(props) {
    super(props);
    this.publishChanges = this.publishChanges.bind(this);
    this.publish = this.publish.bind(this);
  }
  publishChanges() {
    this.child.handleShow(true);
  }
  publish() {
    axios({
      method: 'post',
      url: '/92know/admin/content/publish'
    }).then(
      () => {
        this.child.handleShow(false);
        this.child.showMessage('9 To Know', 'Your changes have been successfully published!');
      },
      () => {
        this.child.showMessage('9 To Know', 'Something went wrong!');
      }
    );
  }
  render() {
    let { loaded, branding } = this.props;
    localStorage.setItem('branding-92k', JSON.stringify(branding));
    const dialingPhone = branding.phone.replaceAll('-', '');
    if (!loaded) {
      return null;
    }
    let { form } = this.props;
    let displayEditContentButton = false;
    let name = '';
    if (form && form.displayEditContentButton) {
      displayEditContentButton = form.displayEditContentButton;
      name = form.user.firstName;
    }
    return (
      <React.Fragment>
        {/*{displayEditContentButton && (*/}
        {/*  <Navbar bg="dark" className="masthead">*/}
        {/*    <span style={{ float: 'left', color: '#FFF' }}>Hello {name}!</span>*/}
        {/*    <Nav.Link href="/92know/" target="_blank" style={{ color: '#FFF' }}>*/}
        {/*      Visit Live*/}
        {/*    </Nav.Link>*/}
        {/*    <Nav className="navbarInfo offset-md-8">*/}
        {/*      <Nav.Link href="/92know/prospects/customize/?customize=true" style={{ color: '#FFF' }} className="">*/}
        {/*        Customize*/}
        {/*      </Nav.Link>*/}
        {/*      <Nav.Link*/}
        {/*        href="/92know/prospects/customize/?preview=true"*/}
        {/*        target="_blank"*/}
        {/*        style={{ float: 'right', color: '#FFF' }}*/}
        {/*        className=""*/}
        {/*      >*/}
        {/*        Preview*/}
        {/*      </Nav.Link>*/}
        {/*      <Nav.Link href="#" style={{ float: 'right', color: '#FFF' }} onClick={this.publishChanges}>*/}
        {/*        Publish*/}
        {/*      </Nav.Link>*/}
        {/*      <PromptDialog*/}
        {/*        onRef={ref => (this.child = ref)}*/}
        {/*        title="Publish Changes"*/}
        {/*        okText="Publish"*/}
        {/*        cancelText="Cancel"*/}
        {/*        isAgree={''}*/}
        {/*        onOk={this.publish}*/}
        {/*      />*/}
        {/*    </Nav>*/}
        {/*  </Navbar>*/}
        {/*)}*/}
        <header class="header-main 92k-logo">
          <nav class="navbar navbar-default">
            <div class="container-fluid">
              <div class="navbar-header">
                <a class="navbar-brand" href="#">
                  <img alt="Retirement Analyzer" class="local-option main-logo" src={branding.logo} />
                  <span>{branding.name}</span>
                </a>
              </div>
              <div className="navbar navbar-right">
                <a className="tel_num" href={'tel:+1' + dialingPhone}>
                  <i class="fas fa-phone"></i>
                  {branding.phone}
                </a>
              </div>
            </div>
          </nav>

          <figure
            class="header__bg-hero  ddd"
            style={{ color: branding.headerFontColor, backgroundColor: branding.darkColor }}
          ></figure>
        </header>
        {false && (
          <Navbar
            bg="dark"
            className="masthead"
            style={{ color: branding.headerFontColor, background: branding.background }}
          >
            <Container>
              <Navbar.Brand href="#home">
                <img
                  alt="RA Logo"
                  src={branding.logo}
                  width="auto"
                  height="70"
                  className="d-inline-block align-top"
                  style={{ float: 'left' }}
                />
                <div className="brand text-wrap">
                  <span className="" style={{ color: branding.headerFontColor }}>
                    {branding.name}
                  </span>
                </div>
              </Navbar.Brand>
              <Nav className="navbarInfo">
                <Nav.Link href="#" className="phone-number" style={{ color: branding.headerFontColor }}>
                  {branding.phone}
                </Nav.Link>
                <Nav.Link href="#">
                  <Card style={{ width: '5em', float: 'right', border: 'none', background: 'transparent' }}>
                    <Card.Header
                      className="headerMonth"
                      style={{ background: `${branding.darkColor} `, color: `${branding.headerFontColor}` }}
                    >
                      {monthNames[date.getMonth()]}
                    </Card.Header>
                    <Card.Body
                      className="headerDate"
                      style={{ background: `${branding.lightColor}`, color: `${branding.headerFontColor}` }}
                    >
                      {date.getDate()}
                    </Card.Body>
                  </Card>
                </Nav.Link>
              </Nav>
            </Container>
          </Navbar>
        )}
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
    loaded: state.mainState.loaded,
    branding: state.mainState.branding,
    form: state.mainState.form,
    ...ownProps
  };
};

export default connect(
  mapStateToProps,
  null
)(Header)
